import { normalizeCurrencyCode, normalizeCurrencySymbol } from './purchaseHelpers';

/** PayPal orderType values from API (CreatePayPalOrderViewModel). */
export const PAYPAL_ORDER_TYPE = {
  SINGLE_PLAN: 1,
  SINGLE_PLAN_WITH_EXPERT: 2,
  EXPERT_ASSISTANCE_ONLY: 3,
};

export function normalizePurchasePlan(raw) {
  if (!raw || typeof raw !== 'object') return null;

  const id = String(raw.id || '').trim();
  if (!id) return null;

  const price = Number(raw.price);
  const badge = raw.badge && typeof raw.badge === 'object' ? raw.badge : {};

  return {
    id,
    orderType: Number(raw.orderType) || 0,
    badge: {
      label: badge.label || '',
      tone: badge.tone || 'teal',
    },
    featured: Boolean(raw.featured),
    popularLabel: raw.popularLabel || '',
    name: raw.name || '',
    description: raw.description || '',
    price: Number.isFinite(price) ? price : 0,
    currencyCode: normalizeCurrencyCode(raw.currencyCode),
    currencySymbol: normalizeCurrencySymbol(raw.currencySymbol || raw.CurrencySymbol),
    features: Array.isArray(raw.features) ? raw.features.filter(Boolean) : [],
    ctaLabel: raw.ctaLabel || 'Choose plan',
  };
}

export function normalizePurchasePlans(payload) {
  if (!Array.isArray(payload)) return [];
  return payload.map(normalizePurchasePlan).filter(Boolean);
}

export function getPurchasePlanById(plans, planId) {
  if (!planId || !Array.isArray(plans)) return null;
  return plans.find((plan) => plan.id === planId) || null;
}
